import React from "react";

const Breadcrumb = () => {
  return (
    <>
      {/* Breadcrumb Section Start */}
      <div className="breadcumb-section">
        <div className="breadcumb-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcumb-content">
                  <h1 className="breadcumb-title">About Us </h1>

                  <ul className="breadcumb-menu">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li className="text-white">/</li>
                    <li className="active">About Us </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Breadcrumb Section End */}
    </>
  );
};

export default Breadcrumb;
